export const formError = Object.freeze({
  general: "We're unable to process your request. Please try again.",
  tooLong: 'The entered text is too long.',
  critical: 'Something went wrong, please try again later.',
  invalid: 'Please enter a valid value.',
});

export const cityFormError = Object.freeze({
  name: {
    empty: 'Please enter a city name.{1}',
    invalid: 'Please enter a valid city name.{1}',
  },
  description: {
    empty: 'Please enter a description.{1}',
    invalid: 'Please enter a valid description.{1}',
  },
  coverPhoto: {
    empty: 'Please upload a cover photo.{1}',
    invalid: 'Please select a valid cover photo.{1}',
  },
  thumbnail: {
    empty: 'Please select a thumbnail.{1}',
    invalid: 'Please select a valid thumbnail.{1}',
  },
  weather_key: {
    empty: 'Please select a weather code.{1}',
    invalid: 'Please select a valid weather key.{1}',
  },
  associated_attractions: {
    empty: 'Please select a minimum one attraction.{2}',
    invalid: 'Please select a valid weather key.{2}',
  },
});

export const attractionFormError = Object.freeze({
  name: {
    empty: 'Please enter a attraction name.',
    invalid: 'Please enter a valid attraction name.',
  },
  gallery: {
    empty: 'Please add  minimum 1 image for attraction gallery.{2}',
  },
  status: {
    empty: 'Status is required.{1}',
    invalid: 'Please select a valid status.{1}',
  },
  latitude: {
    empty: 'Longitude is required.{2}',
  },
  longitude: {
    empty: 'Longitude is required.{2}',
  },
});

export const deviceFormError = Object.freeze({
  name: {
    empty: 'Please enter a device name.{1}',
    invalid: 'Please enter a valid device name.{1}',
  },
  model: {
    color: 'Please select the device color.{1}',
    size: 'Please select the device size.{1}',
  },
  homeScreenWelcomeText: {
    empty: 'Please enter a welcome text for the home screen.{2}',
    invalid: 'Invalid text format for the home screen.{2}',
  },
  homeScreenImg: {
    empty: 'Please provide an image URL for the home screen.{2}',
    invalid: 'Invalid image URL format.{2}',
  },
  settings: {
    showSection: {
      invalid: 'Invalid section settings format.{3}',
    },
  },
  homeScreenMenu: {
    invalid: 'Please enter a maximum 6 item on Home Screen Menu.{4}',
  },
  welcomeScreenMenu: {
    invalid: 'Please enter a maximum 3 item on Welcome Screen Menu.{4}',
  },
  organization: {
    empty: 'Please assign device to organization.{5}',
    invalid: 'Please enter a valid organization id.{5}',
  },
});

export const organizationFormError = Object.freeze({
  name: {
    empty: 'Organization name is required.{1}',
  },
  companyName: {
    empty: 'Company name is required.{1}',
  },
  code: {
    empty: 'Please enter a correct code.{1}',
    invalid: 'Please enter a valid code for web.{1}',
  },
  companyPhone: {
    empty: 'Phone number is required.{1}',
    invalid: 'Please enter a valid phone.{1}',
  },
  companyEmail: {
    empty: 'Please enter a valid email address.{1}',
    invalid: 'Please enter a valid e-mail.{1}',
  },
  city: {
    empty: 'Please enter a city ID.{2}',
    invalid: 'Please enter a valid cityId.{2}',
  },
  companyCity: {
    empty: 'City name is required.{2}',
    invalid: 'City name is required.{2}',
  },
  latitude: {
    empty: 'Longitude is required.{2}',
  },
  longitude: {
    empty: 'Longitude is required.{2}',
  },
  languages: {
    empty: 'Select languages.{3}',
    invalid: 'Please select at least one language.{2}',
  },
});

export const userFormError = Object.freeze({
  name: {
    empty: 'Please enter user name.{1}',
  },
  surname: {
    empty: 'Please enter surname name.{1}',
  },
  email: {
    empty: 'Please select user Email.{1}',
  },
  password: {
    empty: 'Password is required.{1}',
  },
  role: {
    empty: 'Role is required.{1}',
  },
});
